export default class CacheService {
  static cacheInstance;

  cache;

  static getInstance() {
    if (!this.cacheInstance) {
      this.cacheInstance = new CacheService()
      this.cacheInstance.cache = {}
    }
    return this.cacheInstance
  }

  get(key) {
    return this.cache[key] || false
  }

  set(key, value) {
    this.cache[key] = value
  }
}



// WEBPACK FOOTER //
// ./src/services/cacheService.js